// @flow
import React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import Text from 'sail/Text/Text';
import './Search.scss';
import type {SearchResult as SearchResultType} from 'docs/data';
import {defineMessages, FormattedMessage} from 'react-intl';
import {SearchResult} from './SearchResult';

const messages = defineMessages({
  searchNoResults: {
    id: 'docsShell.search.noResults',
    description: 'No search results found',
    defaultMessage: 'No results',
  },
});

export type SearchResultHeading = {|
  title: string,
  type: 'search-result-heading',
|};

type SearchResultListProps = {|
  results: Array<SearchResultType | SearchResultHeading>,
  selectedIndex: number,
  showRecentlyViewed: boolean,
  setSelectedIndex: (idx: number) => void,
  onSearchResultClick: (result: SearchResultType) => Promise<void>,
|};

export const SearchResultList = ({
  results = [],
  selectedIndex,
  setSelectedIndex,
  showRecentlyViewed,
  onSearchResultClick,
}: SearchResultListProps) => {
  if (results.length === 0) {
    return (
      <Box padding={24}>
        <Text color="gray">
          <FormattedMessage {...messages.searchNoResults} />
        </Text>
      </Box>
    );
  }

  const resultComponents = results.map(
    (result: SearchResultType | SearchResultHeading, idx: number) => {
      if (result.type === 'search-result-heading') {
        return (
          <Box
            key={result.title}
            padding={{left: 12, bottom: 8, top: idx > 0 ? 8 : 0}}
          >
            <Text color="dark" weight="medium" size={13}>
              {result.title}
            </Text>
          </Box>
        );
      } else {
        return (
          <SearchResult
            result={result}
            isSelected={selectedIndex === idx}
            onMouseOver={() => setSelectedIndex(idx)}
            key={result.id}
            onSearchResultClick={onSearchResultClick}
          />
        );
      }
    },
  );

  return (
    <Group padding={12} spacing={2}>
      {resultComponents}
    </Group>
  );
};
